module.exports = __webpack_public_path__ + "img/img_mobile_ui_3.a7d99738.png";